import React, { FunctionComponent } from "react";
import Button from "components/Button/Button";
import DynamicHeading from "components/DynamicHeading/DynamicHeading";
import ImageViewer from "components/ImageViewer/ImageViewer";
import Paragraph from "components/Paragraph/Paragraph";
import combineClasses from "helpers/combine-classes";
import styles from "./Slide.module.scss";
import SlideProps from "./SlideProps.interface";
import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import BackgroundMedia from "components/BackgroundMedia/BackgroundMedia";

const Slide: FunctionComponent<SlideProps> = (props) => {
    const headlineCaseClass = props.topSettings?.headlineCase ? styles[`case_${props.topSettings?.headlineCase}`] : undefined;
    const { currentSlide, index } = props;

    const imageAspectRatio = getImageAspectRatio(undefined, props.content.slideImage?.umbracoWidth, props.content.slideImage?.umbracoHeight);

    return (
        <div className={combineClasses(styles.wrapper, currentSlide === index ? styles.is_active : styles.is_inactive)}>
            <div className={styles.container}>
                <div className={styles.text_left}>
                    {/* Tagline */}
                    {props.content.tagline ? (
                        <span className={styles.tagline}>{props.content.tagline}</span>
                    ) : null}

                    {/* Headline */}
                    {props.content.headline ? (
                        <DynamicHeading className={combineClasses(styles.headline, headlineCaseClass)} text={props.content.headline} headlineSize={props.topSettings.headlineSize} headlineWeight={props.topSettings.headlineWeight} />
                    ) : null}

                    {/* Text */}
                    {props.content.bodyText ? (
                        <Paragraph className={styles.text} innerHTML={props.content.bodyText} />
                    ) : null}

                    {/* Buttons */}
                    {props.content.buttons && props.content.buttons.length > 0 ? (
                        <div className={styles.buttons}>
                            {props.content.buttons.map((button, index) => {
                                return (
                                    <Button key={index} to={button.content.link} className={styles.button} variant={button.content.variant} {...button.content}>{button.content.label}</Button>
                                );
                            })}
                        </div>
                    ) : null}
                </div>

                <div className={styles.image_wrapper}>
                    {props.content.slideImage ? (
                        <ImageViewer className={styles.image} src={props.content.slideImage.umbracoFile.src} extensionType={props.content.slideImage.umbracoExtension} focalPoint={props.content.slideImage.umbracoFile.focalPoint} alt={props.content.slideImageAlternative ? props.content.slideImageAlternative : ""} aspectRatioX={imageAspectRatio.aspectRatioX} aspectRatioY={imageAspectRatio.aspectRatioY}/>
                    ) : null }
                </div>
            </div>

            {props.settings.backgroundMedia?.[0] && props.settings.backgroundMedia.length > 0 ? (
                <BackgroundMedia {...props.settings.backgroundMedia[0]} alt={props.settings.backgroundMediaAlternative ? props.settings.backgroundMediaAlternative : ""} />
            ) : null}
        </div>
    );
};

export default Slide;
